import axios from "axios";
import env from "../variables/EndpointEnvironment";
const headers = {
  "Content-Language": localStorage.getItem('i18nextLng'),
}

const SupportCenterAPI = () => {
  return axios.get(`${env.HOST}/layanan-nasabah`, {
    headers,
  });
};

export default SupportCenterAPI;
